
export const apiEndpoint = process.env.REACT_APP_API_URL;

export const gpt3Endpoint = "https://ask-ralphie-api.herokuapp.com/api/v1/answers";

export const routes = {
	userProfile: "profiles?userId=",
	chats: "chats",
	messages: "messages",
	pusher: "pusher/auth",
};

export const googleFontsAPIKey = process.env.REACT_APP_GOOGLE_FONTS_KEY;
export const googleFontsAPIURL = process.env.REACT_APP_GOOGLE_FONTS_URL;

export const appURL = process.env.REACT_APP_APP_URL;

export const privacyPolicyURL = "https://mvvbucket.s3.amazonaws.com/documentation/privacy_notice.pdf";
export const privacyPolicyForPartners = "https://mvvbucket.s3.amazonaws.com/documentation/PrivacyPolicyForPartners.docx.pdf";
export const privacyPolicyAtlantaURl = "https://mvvbucket.s3.amazonaws.com/documentation/privacy_policy_atlanta.pdf";
export const termsOfUseURL = "https://mvvbucket.s3.amazonaws.com/documentation/terms_of_use.pdf";
export const consentFormURL = "https://mvvbucket.s3.amazonaws.com/documentation/consentForm.pdf"
export const faqURL = "https://thevideovets.com/efms031226puravida";

export const paymentUser = "alexander123@frederictonlawyer.com"
